import type { ViewQueryFilter, ViewQueryFilterNode, ViewQueryList } from '@salescore/core'
import { getQueryParameter } from '@salescore/frontend-common'
import { isNotNullish } from 'effect/Predicate'
import Mustache from 'mustache'

export const useGetQueryWithFilterTree = (query: ViewQueryList | undefined): (() => ViewQueryList | undefined) => {
  const getQueryWithFilterTree = (): ViewQueryList | undefined => {
    if (query === undefined) {
      return undefined
    }
    // useSearchQueryで管理するstateはqueryParameterと一致している
    const searchQuery = getQueryParameter('searchQuery') ?? ''
    const searchQueryFilterTree = getSearchQueryFilterTree(query, searchQuery)
    return {
      ...query,
      filterTree: {
        leafs: [],
        logicalOperator: 'and',
        children: [query.filterTree, searchQueryFilterTree].filter(isNotNullish),
      },
    }
  }

  return getQueryWithFilterTree
}

function getSearchQueryFilterTree(query: ViewQueryList, searchQuery: string): ViewQueryFilterNode | undefined {
  if (searchQuery.length === 0) {
    return undefined
  }

  const queries = searchQuery.split(/\s/v)
  const queryTemplate = query.extra?.searchQuery // `"salesforce_account"."name" = '{{ query }}'` の形を期待

  if (queryTemplate !== undefined && queryTemplate !== '') {
    return {
      logicalOperator: 'and' as const,
      leafs: queries.map((query): ViewQueryFilter => ({
        // eslint-disable-next-line sonarjs/todo-tag
        nodePaths: [], // TODO,
        read: {
          sql: Mustache.render(queryTemplate, { query }),
        },
      })),
      children: [],
    }
  }

  return getSearchQueryFilterTreeByFields(query, searchQuery)
}

function getSearchQueryFilterTreeByFields(query: ViewQueryList, searchQuery: string): ViewQueryFilterNode | undefined {
  const searchableFields = query.fields.filter((field) => field.meta.searchable === true)
  if (searchableFields.length === 0) {
    return undefined
  }
  const queries = searchQuery.split(/\s/v)
  const filterNodesForQuery = queries.map((query): ViewQueryFilterNode => {
    const filters = searchableFields.map((field): ViewQueryFilter =>
      // eslint-disable-next-line sonarjs/todo-tag
      // TODO: queryのvalidation
      ({
        nodePaths: [field.nodePath],
        read: {
          sql: `${field.read.labelSql ?? field.read.sql} LIKE '%${query}%'`,
        },
      }),
    )

    // いずれか1つのfieldに、クエリが含まれる
    return {
      logicalOperator: 'or',
      leafs: filters,
      children: [],
    }
  })

  // 全ての検索語句が含まれる
  return {
    logicalOperator: 'and',
    leafs: [],
    children: filterNodesForQuery,
  }
}
